import React, { useState } from "react";
import { IoPersonCircleOutline } from "react-icons/io5";
import { toast } from "react-toastify";
import { Modal } from "../components";
import { changePassword, resetFields } from "../components/Fields";
import {
  useForgetPasswordMutation,
  useMeQuery,
  useResetPasswordMutation,
} from "../redux/auth/authService";
const Profile = () => {
  const auth = JSON.parse(localStorage.getItem("auth"));
  const { data: userData } = useMeQuery();
  const { user } = auth;
  const changePasswordFields = changePassword;
  const [forgetPassword] = useForgetPasswordMutation();
  const [resetPassword] = useResetPasswordMutation();
  const fields = resetFields;
  console.log("user", userData);
  const [showForm, setShowForm] = useState(false);
  const [selected, setSelected] = useState();
  const sendData = (data) => {
    console.log("sendData", data);
    forgetPassword(data)
      .unwrap()
      .then((response) => {
        console.log("response", response);
        if (response.error) {
          toast.error("Erreur lors de l'envoi de l'email.");
          return;
        }
        toast.success("Email envoyé avec succès.");
      })
      .catch((error) => {
        console.error("Erreur lors de l'envoi de l'email :", error);
        toast.error("Une erreur est survenue. Veuillez réessayer.");
      });
  };

  return (
    <div classNameName="m-2 md:m-10 p-2 md:p-10 bg-white rounded-3xl">
      <Modal
        showForm={showForm}
        send={sendData}
        setShowForm={setShowForm}
        fields={fields}
        selectedData={selected}
        selectType={null}
      />
      <link
        rel="stylesheet"
        href="https://demos.creative-tim.com/notus-js/assets/styles/tailwind.css"></link>
      {/* <link rel="stylesheet" href="https://demos.creative-tim.com/notus-js/assets/vendor/@fortawesome/fontawesome-free/css/all.min.css"></link> */}
      <main className="profile-page ">
        <section className="relative block h-500-px">
          <div
            className="absolute top-0 w-full h-full bg-center bg-cover"
            style={{
              backgroundImage:
                "url(https://images.unsplash.com/photo-1499336315816-097655dcfbda?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=crop&amp;w=2710&amp;q=80)",
            }}>
            <span
              id="blackOverlay"
              className="w-full h-full absolute opacity-50 bg-black"></span>
          </div>
          <div className="top-auto bottom-0 left-0 right-0  absolute pointer-events-none overflow-hidden h-70-px">
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0">
              <polygon
                className="text-blueGray-200 fill-current"
                points="2560 0 2560 100 0 100"></polygon>
            </svg>
          </div>
        </section>
        <section className="relative py-16 bg-blueGray-200">
          <div className="container mx-auto px-4">
            <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-lg -mt-64">
              <div className="px-6">
                <div className="flex flex-wrap justify-center">
                  <div className="w-full lg:w-3/12 px-4 lg:order-2 flex justify-center">
                    <div className="relative">
                      <IoPersonCircleOutline size={95} />
                    </div>
                  </div>
                  <div className="w-full lg:w-4/12 px-4 lg:order-3 lg:text-right lg:self-center">
                    <div className="py-6 px-3 mt-32 sm:mt-0">
                      <button
                        onClick={() => {
                          setShowForm(!showForm);
                        }}
                        className="bg-blue-700 active:bg-blue-800 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150"
                        type="button">
                        Changer de mot de passe
                      </button>
                    </div>
                  </div>
                  <div className="w-full lg:w-4/12 px-4 lg:order-1">
                    <div className="flex justify-center py-4 lg:pt-4 pt-8">
                      {/* <div className="mr-4 p-3 text-center">
                        <span className="text-sm text-nowrap font-bold block uppercase tracking-wide text-blueGray-600">
                          {userData?.phone}
                        </span>
                        <span className="text-sm text-blueGray-400">
                          Téléphone
                        </span>
                      </div> */}
                      <div className="mr-4 p-3 text-center">
                        <span className="text-sm font-bold block uppercase tracking-wide text-blueGray-600">
                          {userData?.bureau?.name}
                        </span>
                        <span className="text-sm text-blueGray-400">
                          Bureau
                        </span>
                      </div>
                      {/* <div className="lg:mr-4 p-3 text-center">
                        <span className="text-sm font-bold block uppercase tracking-wide text-blueGray-600">
                          89
                        </span>
                        <span className="text-sm text-blueGray-400">Comments</span>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="text-center mt-12">
                  <h3 className="text-4xl font-semibold leading-normal mb-2 text-blueGray-700 ">
                    {userData?.username}
                  </h3>
                  <div className="text-sm leading-normal mt-0 mb-2 text-blueGray-400 font-bold uppercase">
                    {/* <MdAlternateEmail /> */}
                    {userData?.email}
                  </div>
                  <div className="mb-2 text-blueGray-600">
                    {/* <LiaUsersSolid /> */}
                    Role: {userData?.role.name}
                  </div>
                  <div className="mb-2 text-blueGray-600 mt-10">
                    <i className="fas fa-briefcase mr-2 text-lg text-blueGray-400"></i>
                    BUMDA - Bamako
                  </div>
                </div>
                <div className="mt-10 py-10 border-t border-blueGray-200 text-center">
                  <div className="flex flex-wrap justify-center">
                    <div className="w-full lg:w-9/12 px-4">
                      {/* <p className="mb-4 text-lg leading-relaxed text-blueGray-700">
                        bureau des droits d'auteurs, dont la mission est de ....
                      </p> */}
                      {/* <a href="#pablo" className="font-normal text-pink-500">
                        Show more
                      </a> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Profile;
